/** TODO: Re-export this type through HitL SDK */
import { USER_ROLE } from '@onereach/types-hitl-api';
export { USER_ROLE };

export enum AGENT_STATUS_API {
  AVAILABLE = 'AVAILABLE',
  BUSY = 'BUSY',
  OFFLINE = 'OFFLINE',
}

/**
 * A special UI-only status visible when status on server
 * doesn't match status in client.
 */
export type AGENT_STATUS = AGENT_STATUS_API & { DESYNC: 'DESYNC';};
export const AGENT_STATUS = { ...AGENT_STATUS_API, DESYNC: 'DESYNC' };

/** Time to "Offline" in seconds */
export const DEFAULT_EXPIRE_IN = 3 * 60;
export const DEFAULT_STATUS = AGENT_STATUS_API.AVAILABLE;
export const DEFAULT_STATUS_KEY = DEFAULT_STATUS.toLowerCase();

export const AGENT_STATUS_LABEL = {
  [AGENT_STATUS.AVAILABLE]: 'hitl.common.agent-status.available',
  [AGENT_STATUS.BUSY]: 'hitl.common.agent-status.busy',
  [AGENT_STATUS.OFFLINE]: 'hitl.common.agent-status.offline',
  [AGENT_STATUS.DESYNC]: 'hitl.common.agent-status.desync',
};

export const DEFAULT_STATUS_ICONS = {
  [AGENT_STATUS.AVAILABLE]: 'check',
  [AGENT_STATUS.BUSY]: 'desktop_windows',
  [AGENT_STATUS.DESYNC]: 'power_off',
  [AGENT_STATUS.OFFLINE]: 'block',
};

export const USER_ROLE_LABEL = {
  [USER_ROLE.USER]: 'HITL.common.users.roles.user',
  [USER_ROLE.ADMIN]: 'HITL.common.users.roles.admin',
  [USER_ROLE.SUPER_ADMIN]: 'HITL.common.users.roles.super-admin',
  [USER_ROLE.GUEST]: 'HITL.common.users.roles.guest',
  [USER_ROLE.READONLY]: 'HITL.common.users.roles.guest',
};

export enum STATUS_CHANGE_ACTION_TYPE {
  AUTO = 'Automatic',
  MANUAL = 'Manual',
}

export enum STATUS_CHANGE_REASON {
  INITIAL = 'Initial',
  RESTORE = 'Restore',
  EXPIRE = 'Expire',
}

export const STATUS_CHANGE_SOURCE = 'Agent UI';
